import React from "react";
import { useTable, useRowSelect, usePagination } from "react-table";
import styled from "styled-components";
import { TitleText } from "../../../../ui/Text";

interface TableProps {
  columns: any;
  data: any;
  setModal?: any;
  setScorecard?: any;
  periods?: any;
  owners?: any;
  organisations?: any;
  setFilter?: any;
  filter?: any;
  status?: any;
}

const MeasuresTable = ({ columns, data }: TableProps) => {
  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    selectedFlatRows,
    page,
  }: any = useTable({ columns, data }, useRowSelect, usePagination, (hooks) => {
    hooks.visibleColumns.push((columns) => [
      // Let's make a column for selection
      ...columns,
    ]);
  });  
  return (
    <StyledTable>
      <table {...getTableProps()}>
        <thead>
          {headerGroups.map((headerGroup) => (
            <tr {...headerGroup.getHeaderGroupProps()}>
              {headerGroup.headers.map((column) => (
                <th {...column.getHeaderProps()}>{column.render("Header")}</th>
              ))}
            </tr>
          ))}
        </thead>
        <tbody {...getTableBodyProps()}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <tr {...row.getRowProps}>
                {row.cells.map((cell) => {
                  return (
                    <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </StyledTable>
  );
};

export default MeasuresTable;

const StyledTable = styled.div`
  table {
    width: 100%;
    border-spacing: 0;
    padding: 1em;
    thead {
      background-color: none;
      tr {
        background-color: #fff !important;
      }
    }
    th {
      font-size: 12px;
      color: #a0aebd;
      text-align: left;
    }
    tr {
      padding: 1em 1em;
      display: grid;
      grid-template-columns: 4fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
      color: black;
      font-size: 12px;
      background-color: #f5f6fb !important;
      width: 95%;
      align-items: center;
      margin: 0.3em 0;
      &:hover {
        background-color: #ebeeff;
      }

      td {
        :first-child {
          /* background-color: red; */
        }
        :nth-child(2) {
          /* font-size: 14px;
          font-weight: bold; */
        }
      }
    }

    /* th, */
    /* td {
      margin: 0;
      :last-child {
        border-right: 0;
      }
    } */
  }
`;
